var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warningRequiredFields"},[_c('v-alert',{staticClass:"col-md-12 mandatory-data"},[_c('span',[_vm._v("*")]),_vm._v(" Campo Obrigatório ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }